import emptyToNull from 'app/React/Components/Widget/emptyToNull'
import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function WidgetButtonLine({ leftButtonText, leftButtonUrl, rightButtonText, rightButtonUrl }) {
  const {
    car,
    configuratorUrl
  } = useContext(ConfiguratorContext)

  return (
    <div className='mtt-product__button-section button-section'>
      {emptyToNull(leftButtonText) != null ? (
        <a href={emptyToNull(leftButtonUrl) ?? car.url} className='button transparent'>
          {leftButtonText}
        </a>
      ) : null}
      {emptyToNull(rightButtonText) != null ? (
        <a href={emptyToNull(rightButtonUrl) ?? configuratorUrl} className='button primary'>
          {rightButtonText}
        </a>
      ) : null}
    </div>
  )
}
